module.exports = __webpack_public_path__ + "img/place-of-worship.90b7519a.png";